import { queryKeys as goalsQueryKeys } from '../../../../../api/queryKeys';

enum QueryKey {
  SocialSecurityComparison = 'SocialSecurityComparison',
  SocialSecurityProbability = 'SocialSecurityProbability',
  AnnualBenefitsSummary = 'AnnualBenefitsSummary',
}

export const queryKeys = {
  socialSecurityComparison: (clientId: number, fpId: string) => [
    ...goalsQueryKeys.socialSecurity(clientId, fpId),
    QueryKey.SocialSecurityComparison,
  ],

  socialSecurityProbability: (clientId: number, fpId: string, strategy: string) => [
    ...goalsQueryKeys.socialSecurity(clientId, fpId),
    QueryKey.SocialSecurityProbability,
    strategy,
  ],

  annualBenefitsSummary: (clientId: number, fpId: string, strategy: string) => [
    ...goalsQueryKeys.socialSecurity(clientId, fpId),
    QueryKey.AnnualBenefitsSummary,
    strategy,
  ],

  // Standalone so invalidating the Social Security query prefix does not reset it.
  socialSecurityWhatIfRefresh: (clientId: number, fpId: string) =>
    ['SocialSecurityWhatIfRefresh', clientId, fpId] as const,
};
